import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import HomePageV4View from './submodules/list';

const HomepageViewDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.homepageView}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.homepageView].showView]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/showView`}
				component={HomePageV4View}
				exact
			/>
			<Redirect to={`${path}/showView`} />
		</Switch>
	);
};

export default HomepageViewDashboard;
